module.exports = __webpack_public_path__ + "media/images/social-icons/pinterest-fa3be4726a585d2c70d49e8faf07da2a.svg";